import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../../jsx/layouts/PageTitle";
import ReactPaginate from "react-paginate";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { formatDateTime } from "../../../utils/dateTimeFormate";
import { getAlldataverifiedDwnload, getVerifieddataList } from "../../../services/adminApiService/verifiedlistApiService/VerifiedLIstApiService";
import FilterNumber from "../../../jsx/components/FilterNumberDropDown/FilterNumber";
import SearchFilter from "../../../jsx/components/SearchFilter/SearchFilter";
import useSearchValue from "../../../hooks/useSearchValue";
import DistrictFilter from "../districtFilter/DistrictFilter";
import { LocationContext } from "../../../context/LocationContext";
import CategorySubCategoryFilter from "../categorySubCateogoryFilter/CategorySubCategoryFilter";
import { useCategoryFilter } from "../../../context/CategoryFilterContext";
import RefreshButton from "../../../jsx/components/RefreshButton/RefreshButton";
import { useFilterReset } from "../../../hooks/useFilterReset";
import SportFilter from "../sportFilter/SportFilter";
import { useSport } from "../../../context/SportContext";
import DownloadExcelButton from "../../../jsx/components/DownloadExcelButton.jsx/DownloadExcelButton";
import { VerifiedorganisationExcelHeaders } from "./VerifiedInsituteExcelData";
import { getOrganisationListForExcel } from "../../../services/adminApiService/organisationApi/OrganisationApiService";
import {
  exportToExcel,
  exportVerifiedToExcel,
} from "../../../utils/exportToExcel";
import TextMasked from "../../../utils/TextMasked";

const InsituteVeriedUserList = ({ roletype, roleCategory }) => {
  const { selectedDistrictId, setSelectedDistrictId } =
    useContext(LocationContext);
  const { selectedSubCategoryId, setSelectedSubCategoryId } =
    useCategoryFilter();
  const [verifiedUserdataList, setVerifiedUserdataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {
    searchValue,
    setSearchValue,
    debouncedSearchValue,
    setDebouncedSearchValue,
  } = useSearchValue();
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const handleVerificationInsituteClick = (id) => {
    navigate(`/verification-insitute-view-form/${id}`); // Absolute path
  };
  const { selectedSportId, setSelectedSportId } = useSport();
  const getverifiedListApi = async (
    roletype,
    perPage,
    currentPage,
    searchValue,
    selectedDistrictId,
    selectedCategory,
    selectedSubCategoryId,
    selectedSportId,
  ) => {
    setLoading(true);
    try {
      const response = await getVerifieddataList(
        roletype,
        perPage,
        currentPage,
        searchValue,
        selectedDistrictId,
        selectedCategory,
        selectedSubCategoryId,
        selectedSportId,
      );
      setVerifiedUserdataList(response?.data?.data);
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getverifiedListApi(
      roletype,
      perPage,
      currentPage,
      debouncedSearchValue,
      selectedDistrictId,
      selectedCategory,
      selectedSubCategoryId,
      selectedSportId,
    );
  }, [
    currentPage,
    perPage,
    debouncedSearchValue,
    selectedDistrictId,
    selectedCategory,
    selectedSubCategoryId,
    selectedSportId,
  ]);

  const handlePageChange = (event) => {
    // Adjusting for zero-based index by adding 1
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };
  const handleRefresh = useFilterReset({
    setSearchValue,
    setDebouncedSearchValue,
    setSelectedDistrictId,
    setSelectedSubCategoryId,
    setSelectedCategory,
    setSelectedSubCategory,
    setPerPage,
    setCurrentPage,
    setSelectedSportId,
    fetchFunction: getverifiedListApi,
    fetchArgs: [roletype, 10, 1, "", "", "", "",""],
  });
  useEffect(() => {
    setCurrentPage(1);
    setPerPage(10);
    // setSelectedStatus(0);
    setDebouncedSearchValue("");
    setSelectedDistrictId("");
    setSelectedSubCategoryId("");
    setSelectedSportId("");
  }, []);

  const handleDataToExcel = async () => {
    try {
      const response = await getOrganisationListForExcel(
        searchValue,
        selectedDistrictId,
        selectedSubCategoryId,
        selectedSportId,
      );
      const data = response.data;
      exportVerifiedToExcel(data, "InsitutionListVerified.csv");
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  return (
    <>
      <PageTitle
        activeMenu="Institution Verification List"
        motherMenu="Manage Verification"
      />
      <div className="col-12">
        <div className="card filter-card-wrapper">
          <div className="px-3 d-flex justify-content-between">
            <div className="d-flex py-2 mt-2 mx-2">
              <div>
                <FilterNumber
                  value={perPage}
                  onChange={(val) => {
                    setPerPage(val);
                    setCurrentPage(1); // ✅ sync with download
                  }}
                />
              </div>
              <div>
                <SearchFilter
                  searchValue={searchValue}
                  setSearchValue={setSearchValue}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            </div>
            <div className="d-flex mt-3">
              <div className="mx-2">
                {/* <DownloadExcelButton
                  onClick={async () => {
                    const response = await getAlldataverifiedDwnload(
                      2,
                      debouncedSearchValue,
                      selectedDistrictId,
                      selectedSubCategoryId,
                      selectedSportId
                    );
                    const allData = response?.data?.data?.data || [];
                    const withSerial = allData.map((item, index) => ({
                      serial: index + 1,  // matches header key
                      ...item
                    }));

                    return withSerial;
                  }}
                  data={
                    (verifiedUserdataList?.data || verifiedUserdataList || []).map((item, index) => ({
                      serial: index + 1, // ✅ add serial number
                      ...item,
                    }))
                  }
                  headers={[
                    { label: "Sr.No", key: "serial" }, // ✅ add serial header
                    ...VerifiedorganisationExcelHeaders,
                  ]}
                  fileName="InsitutionListVerified.xlsx"
                  btnName="Download Excel" /> */}

                <DownloadExcelButton
                  userId={2}
                  searchValue={searchValue}
                  selectedDistrictId={selectedDistrictId}
                  selectedSubCategoryId={selectedSubCategoryId}
                  selectedSportId={selectedSportId}
                />
              </div>
              {/* <div className="mx-1">
              <DownloadExcelButton
                headers={[
                    { label: "S.No", key: "serial" }, // Add Serial Number column
                    ...VerifiedorganisationExcelHeaders
                  ]}
                btnName="Download All Data"
                fileName="AllIndividualListVerified.xlsx"
                onClick={async () => {
                    const response = await getAlldataverifiedDwnload(2);
                    const allData = response?.data?.data || [];
                    const withSerial = allData.map((item, index) => ({
                      serial: index + 1,  // matches header key
                      ...item
                    }));

                    return withSerial;
                  }}
              />
            </div> */}
              <div>
                <RefreshButton refreshCallback={handleRefresh} />
              </div>
            </div>
          </div>
          <div className="d-flex mx-4 mt-1">
            <div className="me-2">
              <SportFilter setCurrentPage={setCurrentPage} />
            </div>
            <div>
              <DistrictFilter setCurrentPage={setCurrentPage} />
            </div>
            <div className="mx-2">
              <CategorySubCategoryFilter
                typeId="2"
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                selectedSubCategory={selectedSubCategory}
                setSelectedSubCategory={setSelectedSubCategory}
                placeholderText="Institution"
                setCurrentPage={setCurrentPage}
              />
            </div>
          </div>

          <div className="card-body">
            {loading ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="w-100 table-responsive">
                <div id="example_wrapper" className="dataTables_wrapper">
                  <table id="example" className="display w-100 dataTable">
                    <thead>
                      <tr>
                        <th>SN</th>
                        {/* <th>Legal Entity</th> */}
                        <th>Reg. No</th>
                        <th>Unique Id</th>
                        <th>Name of Institution</th>
                        {/* <th>Contact Person Email</th> */}
                        <th>Contact Person Mobile</th>
                        <th>Registration Date</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {verifiedUserdataList?.data?.length > 0 ? (
                        verifiedUserdataList.data.map((data, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1 + (currentPage - 1) * perPage}</td>
                              {/* <td>{data?.name_of_legel_entity}</td> */}
                              <td>{data?.organization?.registration_number}</td>
                              <td>{data?.atom_id}</td>
                              <td>
                                {data?.organization?.name_of_organization}
                              </td>
                              {/* <td>
                                {data?.organization?.contact_person_email}
                              </td> */}
                              {/* <td>
                                {data?.organization?.contact_person_contact}
                              </td> */}
                               <td><TextMasked value={data?.organization?.contact_person_contact} type="phone" /></td>
                              <td>{formatDateTime(data?.created_at)}</td>

                              <td>
                                <span className="text-success">Verified</span>
                              </td>
                              <td>
                                <div className="d-flex">
                                  <Button
                                    style={{ whiteSpace: "nowrap" }}
                                    onClick={() =>
                                      handleVerificationInsituteClick(data?.id)
                                    }
                                  >
                                    {" "}
                                    View More{" "}
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            Data is not available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
        <ReactPaginate
          nextLabel="next >"
          onPageChange={handlePageChange}
          pageRangeDisplayed={8}
          marginPagesDisplayed={7}
          pageCount={Math.ceil(verifiedUserdataList?.total / perPage)}
          previousLabel="< previous"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination d-flex flex-wrap"
          activeClassName="active"
          renderOnZeroPageCount={null}
          forcePage={currentPage - 1}
        />
      </div>
    </>
  );
};

export default InsituteVeriedUserList;
